import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './views/login/login.component';
import { SignUpComponent } from './views/sign-up/sign-up.component';
import { PasswordResetEmailComponent } from './views/password-reset-email/password-reset-email.component';
import { PasswordResetComponent } from './views/password-reset/password-reset.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'signup',
    component: SignUpComponent
  },
  {
    path: 'passwordresetemail',
    component: PasswordResetEmailComponent
  },
  {
    path: 'e47bb3b663f64a05afb9fa91ac9d72c4',
    component: PasswordResetComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class AuthRoutingModule { }
